import { render, staticRenderFns } from "./DefaultsProduct.vue?vue&type=template&id=58d2434a&scoped=true&"
import script from "./DefaultsProduct.vue?vue&type=script&lang=js&"
export * from "./DefaultsProduct.vue?vue&type=script&lang=js&"
import style0 from "./DefaultsProduct.vue?vue&type=style&index=0&id=58d2434a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d2434a",
  null
  
)

export default component.exports